module.exports = __webpack_public_path__ + "img/combo_bar.f24fff49.png";